import React, { useState, useEffect } from "react";
import Skeleton from "@mui/material/Skeleton";
import dummyUser from "../../../../../assets/images/dummy/dummy-user.png";
import { getAsset } from "../../../../../helpers/helper";

const MemberAvatar = ({ src, alt = "Team member avatar" }) => {
  const [loaded, setLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setLoaded(false);
    setHasError(false);
  }, [src]);

  const hasUploadedImage = Boolean(src && !hasError);
  const imageSrc = hasUploadedImage ? getAsset(src) : dummyUser;

  const handleLoad = () => {
    setLoaded(true);
  };

  const handleError = () => {
    if (!hasError) {
      setHasError(true);
    }
    setLoaded(true);
  };

  return (
    <span className="shop-manage-avatar">
      {!loaded && (
        <Skeleton
          className="shop-manage-avatar-skeleton"
          variant="circular"
          width="100%"
          height="100%"
          animation="wave"
        />
      )}
      <img
        src={imageSrc}
        alt={alt}
        onLoad={handleLoad}
        onError={handleError}
        className={loaded ? "is-loaded" : ""}
      />
    </span>
  );
};

export default MemberAvatar;

